export const modals = {
  matchesInfo: "matchesInfo",
  missingInfo: "missingInfo",
  message: "message",
  successMessage: "successMessage",
  questionOpenToOther: "questionOpenToOther",
  contactInfo: "contactInfo"
};

// GROWTH-6582: the key for a Request Received case is `requestReceived`, whose value is the string "pending". There is no
// `pending` key, and reading a missing key gives undefined without an error, which is how an undefined sat in a list of
// statuses unnoticed. constants/referralRequestDetail.test.js fails on any reference to a key these two objects lack.
export const statusesConstant = Object.freeze({
  missingInformation: "missingInformation",
  matches: "matches",
  match: "match",
  notMatch: "notMatch",
  reviewed: "reviewed",
  rejected: "rejected",
  pendingReview: "pendingReview",
  requestReceived: "pending"
});

export const statusesConstantKeys = Object.freeze({
  missingInformation: "dashboard_referrals_details_status_missinginformation",
  matches: "dashboard_referrals_details_status_morematches",
  match: "dashboard_referrals_details_status_1match",
  notMatch: "dashboard_referrals_details_status_notmatch",
  reviewed: "dashboard_referrals_details_status_reviewed",
  rejected: "dashboard_referrals_details_status_rejected",
  pendingReview: "dashboard_referrals_details_status_pending",
  requestReceived: "dashboard_referrals_details_status_received"
});

// GROWTH-6565: statuses where the requester may still edit contact details / description.
export const editableCaseStatuses = [statusesConstant.pendingReview, statusesConstant.requestReceived, statusesConstant.missingInformation];
